import React from 'react';
import centredForm from '../components/centredForm';
import PrivacyPolicy from '../../forms/PrivacyPolicy';
import FormTitle from '../components/FormTitle';

export default centredForm(PrivacyPolicy, <FormTitle title="privacyPolicy" />);



// WEBPACK FOOTER //
// ./src/view/scenes/PrivacyPolicy/index.js